import React, { useEffect, useState } from 'react';
import VideoWrapper from 'components/widgets/VideoWrapper/VideoWrapper';
import ChatComponent from './components/widgets/Chat/ChatComponent';
import AllowVolume from 'components/shared/AllowVolume/AllowVolume';
import { useSelector } from 'react-redux';
import { getAgree, getAgreeComp, getPrivacy } from './store/chat/chat-selectors';
import Privacy from './components/docs/privacy/privacy';
import Agree from './components/docs/agree/agree';
import { getIsOverlayVisible } from './store/stream/stream-selectors';
// import { useYandexMetrika } from 'hooks/useYandexMetrika';
import { useMetrikaHit } from 'hooks/useMetrikaHit';
import { YMInitializer } from 'react-yandex-metrika';
import { trackAnalyticsEvent, trackAnalyticsSession } from 'utils/analytics';

const App: React.FC = () => {
  const agree = useSelector(getAgree);
  const agreeComp = useSelector(getAgreeComp);
  const isOverlayVisible = useSelector(getIsOverlayVisible);
  const isPrivacy = useSelector(getPrivacy);
  const METRIKA_ID = Number(process.env.REACT_APP_METRIKA_ID);
  // useYandexMetrika(METRIKA_ID, {
  //   defer: true,
  //   ssr: true,
  //   webvisor: true,
  //   clickmap: true,
  //   ecommerce: 'dataLayer',
  //   accurateTrackBounce: true,
  //   trackLinks: true,
  // });

  useMetrikaHit();
  useEffect(() => {
    return trackAnalyticsSession(process.env.REACT_APP_API_URL);
  }, []);
  useEffect(() => {
    const trackExternalLink = (event: MouseEvent) => {
      const anchor = (event.target as HTMLElement).closest('a[href]') as HTMLAnchorElement | null;
      if (anchor && /^https?:/i.test(anchor.href) && !anchor.href.startsWith(window.location.origin)) {
        trackAnalyticsEvent(process.env.REACT_APP_API_URL, 'external_link_clicked', {
          destination_host: new URL(anchor.href).hostname,
        });
      }
    };
    document.addEventListener('click', trackExternalLink);
    return () => document.removeEventListener('click', trackExternalLink);
  }, []);
  // Добавляем проверку для отображения Privacy
  useEffect(() => {
    const handleResize = () => {
      if (window.innerHeight < 600) {
        // Если высота окна меньше 600px, значит клавиатура открыта
        document.body.style.overflow = 'hidden'; // Блокируем прокрутку
      } else {
        document.body.style.overflow = ''; // Разблокируем прокрутку
      }
    };

    // Слушаем изменение размера окна
    window.addEventListener('resize', handleResize);

    // Очистка обработчика при размонтировании компонента
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const updateHeight = () => {
      // Проверяем, если ширина окна меньше 1024px
      if (window.innerWidth < 1024) {
        const windowHeight = window.innerHeight;
        const newHeight = windowHeight - 150; // Оставляем пространство для других элементов
        const chatContainer = document.querySelector('.ChatComponent_chatContainerHistory__0yDcD');

        if (chatContainer) {
          chatContainer.setAttribute('style', `height: ${newHeight}px`);
        }
      }
    };

    updateHeight(); // Устанавливаем высоту при загрузке

    // Обновляем высоту при изменении размера окна
    window.addEventListener('resize', updateHeight);

    return () => {
      window.removeEventListener('resize', updateHeight);
    };
  }, []);
  return (
    <>
      <>
        <YMInitializer
          accounts={[METRIKA_ID]}
          options={{
            defer: true,
            // ssr: true,
            webvisor: true,
            clickmap: true,
            ecommerce: 'dataLayer',
            accurateTrackBounce: true,
            trackLinks: true,
          }}
          version="2"
        />
        {!isPrivacy && isOverlayVisible && <div className="overlay" id="overlay"></div>}
        <div
          style={isPrivacy ? { display: 'none' } : {}}
          id="content"
          className="content-container"
        >
          <VideoWrapper />
          <ChatComponent />
          {!agree && <AllowVolume />}
        </div>
        <div style={!isPrivacy ? { display: 'none' } : { overflowY: 'scroll' }}>
          <Privacy />
        </div>
      </>
    </>
  );
};

export default App;
